import React from 'react';
import styled from 'styled-components';
import MessageGroup from './MessageGroup';

import { TAppElkMessage } from 'TProtocol/prototypes/events/messages';

const MessageHistory = ({ messages }: { messages: TAppElkMessage[] }) => {
  return <>
    <MessageBox>
      <MessageTitle>
        History
      </MessageTitle>
      <MessageGroup messages={messages}/>
    </MessageBox>
  </>;

};

const MessageBox = styled.div`
`;

const MessageTitle = styled.div`
  font-size: 20px;
  margin: 20px 0 10px;
`;

export default MessageHistory;
